__turbopack_context__.v({
  "accordionSlideOverwrite": "partnerLoginContent-module-scss-module__aPh_3G__accordionSlideOverwrite",
  "fadeIn": "partnerLoginContent-module-scss-module__aPh_3G__fadeIn",
  "fadeOut": "partnerLoginContent-module-scss-module__aPh_3G__fadeOut",
  "footer": "partnerLoginContent-module-scss-module__aPh_3G__footer",
  "header": "partnerLoginContent-module-scss-module__aPh_3G__header",
  "main": "partnerLoginContent-module-scss-module__aPh_3G__main",
  "scaleIn": "partnerLoginContent-module-scss-module__aPh_3G__scaleIn",
  "scaleOut": "partnerLoginContent-module-scss-module__aPh_3G__scaleOut",
  "signupLink": "partnerLoginContent-module-scss-module__aPh_3G__signupLink",
  "subtitle": "partnerLoginContent-module-scss-module__aPh_3G__subtitle",
  "title": "partnerLoginContent-module-scss-module__aPh_3G__title",
  "zoomIn": "partnerLoginContent-module-scss-module__aPh_3G__zoomIn",
  "zoomOut": "partnerLoginContent-module-scss-module__aPh_3G__zoomOut",
});
